module.exports = __webpack_public_path__ + "img/moneybag.696dfe29.png";